export default __webpack_public_path__ + "static/media/supply-green.81c3ca6a.svg";